import React from "react"

const SharedTanstackDevTools =
  process.env.REACT_APP_release === "true"
    ? () => null
    : (() => {
        const DevTools = React.lazy(
          () =>
            import("@myvp/shared/src/dev-tools/internal-shared-tanstack-dev-tools")
        )
        return () => (
          <React.Suspense>
            <DevTools />
          </React.Suspense>
        )
      })()

export default SharedTanstackDevTools
